import React from 'react';

import { LoadingDots, LoadingDotsProps } from './LoadingDots';
import styles from './Dots.module.scss';

interface PageLoadingDotsProps extends LoadingDotsProps {
    wrapperHeight?: string,
    dotSize?: string
    numberOfDots?: number;
    ragColours?: boolean;
    label?: string;
}

export const PageLoadingDots: React.FC<PageLoadingDotsProps> = ({ wrapperHeight = '33px', dotSize = '20px', numberOfDots = 5, ragColours = false, label }) => (
    <div className={styles.spinnerWrapper} data-testid='dataset-instance-extracting-wrapper'>
        <LoadingDots wrapperHeight={wrapperHeight} dotSize={dotSize} numberOfDots={numberOfDots} ragColours={ragColours} />
        {label && <div className={styles.spinnerLabel}>{label}</div>}
    </div>
);
